import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import OfferFlipCountdownBanner from "./OfferCountdownBanner";
import { discount } from "./apipath";

export default function GlobalCampaignBanner() {
  const { pathname } = useLocation();
  const [data, setData] = useState(null);

  const isAdmin = pathname.startsWith("/adm");

  useEffect(() => {
    if (isAdmin) return;

    let mounted = true;
    const auth = JSON.parse(localStorage.getItem("auth") || "{}");

    if (!auth.mem_id) {
      setData({ enabled: false });
      return;
    }

    axios
      .get(`${discount}consult-offer`, {
        params: { mem_id: auth.mem_id }
      })
      .then((res) => {
        if (mounted) setData(res.data);
      })
      .catch(() => {
        if (mounted) setData({ enabled: false });
      });

    return () => {
      mounted = false;
    };
  }, [isAdmin]);

  if (isAdmin) return null;
  if (!data?.enabled) return null;

  return (
    <OfferFlipCountdownBanner
      endAt={data.end_at}
      title={data.title}
      subtitle={data.subtitle}
      discounts={data.discounts || []}
      ctaText="立即選購"
      ctaHref="/quickbuy"
      allowClose={true}
      showDemoControls={false}
    />
  );
}